import React from 'react';
import CollectionEmptyModal from './CollectionEmptyModal.tsx';
import NoRadioIcon from 'components/svg/NoRadioIcon';
import NoPodcastIcon from 'components/svg/NoPodcastIcon';

interface CollectionEmpty {
  contentTypeId: string;
}

const modalTitle = {
  favoriteRadiozender: 'Je hebt nog geen favoriete radiozenders gekozen',
  favoritePodcast: 'Je hebt nog geen favoriete podcasts gekozen',
};

const links = {
  radiozenders: 'radiozenders',
  podcasts: 'podcasts',
};

const buttonText = {
  radiozender: 'Zoek een radiozender',
  podcast: 'Zoek een podcast',
};

const CollectionEmpty = ({ contentTypeId }: CollectionEmpty): JSX.Element => {
  switch (contentTypeId) {
    case 'favoriteStationCollection':
      return (
        <CollectionEmptyModal
          data-testid="collection-empty-favoriteStation"
          icon={<NoRadioIcon />}
          buttonText={buttonText.radiozender}
          link={links.radiozenders}
          title={modalTitle.favoriteRadiozender}
        />
      );
    case 'favoritePodcastCollection':
      return (
        <CollectionEmptyModal
          data-testid="collection-empty-favoritePodcast"
          icon={<NoPodcastIcon />}
          buttonText={buttonText.podcast}
          link={links.podcasts}
          title={modalTitle.favoritePodcast}
        />
      );
    default:
      return <div data-testid="collection-empty"></div>;
  }
};

export default CollectionEmpty;
